module.exports = __webpack_public_path__ + "static/media/case-banner.6d8326b7.png";